import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { getAPI } from "../../service/http-service";
import { CommonEndpoint } from "../../service/endpointConfig/CommonEndpoint";
import { CommonUtil } from "../../util/Utils";

let initialState: any = {
  subAreaResponse: {},
};

// Get SubArea API call
export const SubAreaService = createAsyncThunk(
  "master/subArea",
  async (subArea: any) => {
    try {
      return await getAPI(
        `${CommonEndpoint.subArea}${CommonUtil.appendQueryStr(
          subArea.ids,
          "areaIds"
        )}`
      );
    } catch (err) {
      return err;
    }
  }
);

const subAreaSlice = createSlice({
  name: "subArea",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(
      SubAreaService.fulfilled,
      (state, action: PayloadAction<any>) => {
        state.loading = false;
        state.status = action.payload?.status;
        state.error = "";
        state.data = action.payload?.data?.data;
      }
    );
    builder.addCase(SubAreaService.rejected, (state, action) => {
      state.loading = false;
      state.status = -1;
      state.error = action.error.message || "Something went wrong";
      state.data = {};
    });
  },
});

const subAreaReducer = subAreaSlice.reducer;
export default subAreaReducer;
